export default __webpack_public_path__ + "static/char-s-38-ko-45dce166993380e54ae11dc6df70b189.png";